(function() {
  if (window.__bmHomepageReviewsRelocator) return;
  window.__bmHomepageReviewsRelocator = true;

  function isHomepage() {
    var main = document.getElementById('MainContent');
    return !!(main && main.getAttribute('data-template') === 'index');
  }

  function getProductsSection() {
    return document.querySelector('.ui-test-collection-list') ||
      document.getElementById('shopify-section-template--18589813014633__collection_list_de48hq');
  }

  function getReviewSection() {
    var carousel = document.querySelector('.jdgm-widget.jdgm-cards-carousel');
    return carousel ? carousel.closest('.shopify-section') : null;
  }

  function moveReviewsAfterProducts() {
    if (!isHomepage()) return false;

    var productsSection = getProductsSection();
    var reviewSection = getReviewSection();

    if (!productsSection || !reviewSection) return false;
    if (productsSection.nextElementSibling === reviewSection) return true;

    productsSection.insertAdjacentElement('afterend', reviewSection);
    return true;
  }

  function boot() {
    if (!isHomepage()) return;

    moveReviewsAfterProducts();

    var attempts = 0;
    var intervalId = window.setInterval(function() {
      attempts += 1;
      var moved = moveReviewsAfterProducts();
      if (moved || attempts > 80) {
        window.clearInterval(intervalId);
      }
    }, 500);

    var observer = new MutationObserver(function() {
      moveReviewsAfterProducts();
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });

    window.setTimeout(function() {
      observer.disconnect();
      window.clearInterval(intervalId);
    }, 45000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }
})();
